"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fund = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var systemTab_1 = require("../../model/systemTab");
var service_1 = require("../../../library/base/service");
// @ts-ignore
var Fund = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Fund, _super);
    function Fund() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '基金标签';
        _this.code = '106025';
        _this.desc = "";
        _this.requestParams = new systemTab_1.FundRequest();
        // public responseParams: LoginResponse;
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Fund;
}(service_1.BaseService));
exports.Fund = Fund;
//# sourceMappingURL=fund.js.map